import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Route, ActivatedRoute, Router } from '@angular/router';

/* export interface Sklop {
  value: string;
  viewValue: string;
} */

/* export interface Spremenljivka {
  value: string;
  viewValue: string;
} */

export interface Scenarij {
  value: string;
  viewValue: string;
}

export interface Obdobje {
  value: string;
  viewValue: string;
}

export interface TempKazalniki {
  value: string;
  viewValue: string;
}

export interface PadKazalniki {
  value: string;
  viewValue: string;
}

export interface SPI {
  value: string;
  viewValue: string;
}

export interface SPEI {
  value: string;
  viewValue: string;
}

export interface Pretok {
  value: string;
  viewValue: string;
}

export interface Trajanje {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'app-filter3',
  templateUrl: './filter3.component.html',
  styleUrls: ['./filter3.component.css']
})
export class Filter3Component implements OnInit {
  name: string;

  selected1 = undefined;
  selected2 = undefined;
  selected3 = undefined;
  selected3a = undefined;
  selected4 = undefined;
  selected4a = undefined;
  selected4b = undefined;
  selected4c = undefined;
  selected4d = undefined;
  selected5 = undefined;
  selected6 = undefined;

  public izbira = [
    {value: 1, viewValue: 'Temperatura'},
    {value: 2, viewValue: 'Padavine'},
    {value: 3, viewValue: 'Sneg'},
    {value: 4, viewValue: 'Sončno obsevanje'},
    {value: 5, viewValue: 'Veter'},
    {value: 6, viewValue: 'Vodna bilanca'},
    {value: 7, viewValue: 'Hidrološke spremenljivke'},
    {value: 8, viewValue: 'Kazalniki suše'},
    {value: 9, viewValue: 'Raba energije za ogrevanje in hlajenje'}, 
    {value: 10, viewValue: 'Hidropotencial'}
  ];

  /* spremenljivka: Spremenljivka[] = [
    {value: 'spr-0', viewValue: 'Povprečna temperatura'},
    {value: 'spr-1', viewValue: 'Najvišja temperatura'},
    {value: 'spr-2', viewValue: 'Najnižja temperatura'},
    {value: 'spr-3', viewValue: 'Temperaturni kazalniki'},
    {value: 'spr-5', viewValue: 'Višina padavin'},
    {value: 'spr-8', viewValue: 'Padavinski kazalniki'},
    {value: 'spr-9', viewValue: 'Referenčna evapotranspiracija'},
    {value: 'spr-12', viewValue: 'Napajanje podzemnih voda'},
    {value: 'spr-14', viewValue: 'Srednji pretoki'},
    {value: 'spr-15', viewValue: 'Veliki pretoki'},
    {value: 'spr-16', viewValue: 'Mali pretoki'},
    {value: 'spr-17', viewValue: 'Povratne dobe za velike pretoke'}
  ]; */

 /*  scenarij: Scenarij[] = [
    {value: 'scenarij-0', viewValue: 'RCP2.6'},
    {value: 'scenarij-1', viewValue: 'RCP4.5'},
    {value: 'scenarij-2', viewValue: 'RCP8.5'}
  ]; */

  obdobje: Obdobje[] = [
    {value: 'obdobje-0', viewValue: 'Bližnja prihodnost (2011-2040)'},
    {value: 'obdobje-1', viewValue: 'Sredina stoletja (2041-2070)'},
    {value: 'obdobje-2', viewValue: 'Konec stoletja (2071-2100)'},
  ];

  tempKazalniki: TempKazalniki[] = [
    {value: 'tmpKaz-0', viewValue: 'Kazalnik vročine pozitiven (EHF)'},
    {value: 'tmpKaz-6', viewValue: 'Skupna dolžina toplih obdobij (WSDI)'},
    {value: 'tmpKaz-7', viewValue: 'Število toplih dni (SU)'},
    {value: 'tmpKaz-8', viewValue: 'Število vročih dni'},
    {value: 'tmpKaz-9', viewValue: 'Število tropskih noči (TR)'},
    {value: 'tmpKaz-10', viewValue: 'Kazalnik najtoplejših dni (TX90p)'},
    {value: 'tmpKaz-11', viewValue: 'Kazalnik mraza negativen (ECF)'},
    {value: 'tmpKaz-14', viewValue: 'Skupna dolžina hladnih obdobij (CSDI)'},
    {value: 'tmpKaz-15', viewValue: 'Število hladnih dni (FD)'},
    {value: 'tmpKaz-16', viewValue: 'Število ledenih dni (ID)'},
    {value: 'tmpKaz-17', viewValue: 'Kazalnik najhladnejših dni (TN10p)'}
  ];

  padKazalniki: PadKazalniki[] = [
    {value: 'padKaz-0', viewValue: 'Dolžina najdaljšega suhega obdobja v letu (CDD)'},
    {value: 'padKaz-1', viewValue: 'Dolžina najdaljšega mokrega obdobja v letu (CWD)'},
    {value: 'padKaz-2', viewValue: 'Letna višina padavin iz najbolj mokrih dni (R95pTOT)'},
    {value: 'padKaz-5', viewValue: 'Število dni na leto z več kot 10 mm padavin (R10mm)'},
    {value: 'padKaz-8', viewValue: 'Največja dnevna višina padavin (Rx1day)'},
    {value: 'padKaz-9', viewValue: 'Največja petdnevna višina padavin (Rx5day)'}
  ];

  spi: SPI[] = [
    {value: 'spi-0', viewValue: 'SPI-1'},
    {value: 'spi-1', viewValue: 'Pogostost suše (SPI-1)'},
    {value: 'spi-2', viewValue: 'SPI-3'},
    {value: 'spi-3', viewValue: 'Pogostost suše (SPI-3)'},
    {value: 'spi-4', viewValue: 'Trajanje suše (SPI-3)'},
    {value: 'spi-5', viewValue: 'Magnituda suše (SPI-3)'},
    {value: 'spi-6', viewValue: 'SPI-6'},
    {value: 'spi-7', viewValue: 'Pogostost suše (SPI-6)'},
    {value: 'spi-8', viewValue: 'Trajanje suše (SPI-6)'},
    {value: 'spi-9', viewValue: 'Magnituda suše (SPI-6)'}
  ];

  spei: SPEI[] = [
    {value: 'spei-1', viewValue: 'Pogostost suše (SPEI-1)'},
    {value: 'spei-2', viewValue: 'Trajanje suše (SPEI-1)'},
    {value: 'spei-3', viewValue: 'Magnituda suše (SPEI-1)'},
    {value: 'spei-4', viewValue: 'Pogostost suše (SPEI-3)'},
    {value: 'spei-5', viewValue: 'Trajanje suše (SPEI-3)'},
    {value: 'spei-6', viewValue: 'Magnituda suše (SPEI-3)'},
    {value: 'spei-7', viewValue: 'Pogostost suše (SPEI-6)'},
    {value: 'spei-8', viewValue: 'Trajanje suše (SPEI-6)'},
    {value: 'spei-9', viewValue: 'Magnituda suše (SPEI-6)'}
  ];

  pretok: Pretok[] = [
    {value: 'pretok-0', viewValue: 'Pretok pri 0,5 odstotkih časa'},
    {value: 'pretok-1', viewValue: 'Pretok pri 5 odstotkih časa'},
    {value: 'pretok-2', viewValue: 'Pretok pri 10 odstotkih časa'},
    {value: 'pretok-3', viewValue: 'Pretok pri 25 odstotkih časa'},
    {value: 'pretok-4', viewValue: 'Pretok pri 50 odstotkih časa'},
    {value: 'pretok-5', viewValue: 'Pretok pri 75 odstotkih časa'},
    {value: 'pretok-6', viewValue: 'Pretok pri 90 odstotkih časa'},
    {value: 'pretok-7', viewValue: 'Pretok pri 95 odstotkih časa'},
  ];

  trajanje: Trajanje[] = [
    {value: 'trajanje-0', viewValue: 'Trajanje pretoka pri 0,5 odstotkih časa'},
    {value: 'trajanje-1', viewValue: 'Trajanje pretoka pri 5 odstotkih časa'},
    {value: 'trajanje-2', viewValue: 'Trajanje pretoka pri 10 odstotkih časa'},
    {value: 'trajanje-3', viewValue: 'Trajanje pretoka pri 25 odstotkih časa'},
    {value: 'trajanje-4', viewValue: 'Trajanje pretoka pri 50 odstotkih časa'},
    {value: 'trajanje-5', viewValue: 'Trajanje pretoka pri 75 odstotkih časa'},
    {value: 'trajanje-6', viewValue: 'Trajanje pretoka pri 90 odstotkih časa'},
    {value: 'trajanje-7', viewValue: 'Trajanje pretoka pri 95 odstotkih časa'},
  ];

  defualtOption = null;
  public spremenljivka = [];
  private scenarij1 = [];
  private tempPrag =[]; 

  selectDisabled3 = true;
  selectDisabled3a = true;
  selectDisabled4 = true;
  selectDisabled4a = true;
  selectDisabled4b = true;
  selectDisabled4c = true;
  selectDisabled4d = true;
  selectDisabled5 = true;
  selectDisabled6 = true;
  hidden3 = false;
  hidden3a = false;
  hidden4 = false;
  hidden4a = false;
  hidden4b = false;
  hidden4c = false;
  hidden4d = false;
  hidden5 = false;
  hidden6 = false;

  firstDropDownChanged(viewValue: any) {
    const obj = this.izbira[viewValue];
    console.log(obj);
    
    this.selected2 = undefined;
    this.selected3 = undefined;
    this.selected3a = undefined;
    this.selected4 = undefined;
    this.selected4a = undefined;
    this.selected4b = undefined;
    this.selected4c = undefined;
    this.selected4d = undefined;
    this.selected5 = undefined;
    this.selected6 = undefined;

    if (!obj) return;
    
    if (obj.value == 1) {
      this.spremenljivka = [
        {value: 'spr-0', viewValue: 'Povprečna temperatura'},
        {value: 'spr-1', viewValue: 'Najvišja temperatura'},
        {value: 'spr-2', viewValue: 'Najnižja temperatura'},
        {value: 'spr-3', viewValue: 'Temperaturni kazalniki'}
      ];
      this.selectDisabled3 = true;
      this.selectDisabled3a = true;
      this.selectDisabled4 = true;
      this.selectDisabled4a = true;
      this.selectDisabled4b = true;
      this.selectDisabled4c = true;
      this.selectDisabled4d = true;
      this.selectDisabled5 = true;
      this.selectDisabled6 = true;
      this.hidden3 = false;
      this.hidden3a = false;
      this.hidden4 = false;
      this.hidden4a = false;
      this.hidden4b = false;
      this.hidden4c = false;
      this.hidden4d = false;
      this.hidden5 = false;
      this.hidden6 = false;
    }
    
    else if (obj.value == 2) {
      this.spremenljivka = [
        {value: 'spr-5', viewValue: 'Višina padavin'},
        {value: 'spr-8', viewValue: 'Padavinski kazalniki'}
      ];
      this.selectDisabled3 = true;
      this.selectDisabled3a = true;
      this.selectDisabled4 = true;
      this.selectDisabled4a = true;
      this.selectDisabled4b = true;
      this.selectDisabled4c = true;
      this.selectDisabled4d = true;
      this.selectDisabled5 = true;
      this.selectDisabled6 = true;
      this.hidden3 = false;
      this.hidden3a = false;
      this.hidden4 = false;
      this.hidden4a = false;
      this.hidden4b = false;
      this.hidden4c = false;
      this.hidden4d = false;
      this.hidden5 = false;
      this.hidden6 = false;
    }

    else if (obj.value == 3) {
      this.spremenljivka = [
        {value: 'spr-31', viewValue: 'Število dni s snežno odejo'},
        {value: 'spr-32', viewValue: 'Količina vode v novozapadlem snegu'}
      ];
      this.selectDisabled3 = true;
      this.selectDisabled3a = true;
      this.selectDisabled4 = true;
      this.selectDisabled4a = true;
      this.selectDisabled4b = true;
      this.selectDisabled4c = true;
      this.selectDisabled4d = true;
      this.selectDisabled5 = true;
      this.selectDisabled6 = true;
      this.hidden3 = false;
      this.hidden3a = false;
      this.hidden4 = false;
      this.hidden4a = false;
      this.hidden4b = false;
      this.hidden4c = false;
      this.hidden4d = false;
      this.hidden5 = false;
      this.hidden6 = false;
    }

    else if (obj.value == 4) {
      this.spremenljivka = [
        {value: 'spr-41', viewValue: 'Globalni obsev'},
        {value: 'spr-42', viewValue: 'Trajanje sončnega obsevanja'}
      ];
      this.selectDisabled3 = true;
      this.selectDisabled3a = true;
      this.selectDisabled4 = true;
      this.selectDisabled4a = true;
      this.selectDisabled4b = true;
      this.selectDisabled4c = true;
      this.selectDisabled4d = true;
      this.selectDisabled5 = true;
      this.selectDisabled6 = true;
      this.hidden3 = false;
      this.hidden3a = false;
      this.hidden4 = false;
      this.hidden4a = false;
      this.hidden4b = false;
      this.hidden4c = false;
      this.hidden4d = false;
      this.hidden5 = false;
      this.hidden6 = false;
    }
    else if (obj.value == 5) {
      this.spremenljivka = [
        {value: 'spr-51', viewValue: 'Povprečna hitrost vetra'}
      ];
      this.selectDisabled3 = true;
      this.selectDisabled3a = true;
      this.selectDisabled4 = true;
      this.selectDisabled4a = true;
      this.selectDisabled4b = true;
      this.selectDisabled4c = true;
      this.selectDisabled4d = true;
      this.selectDisabled5 = true;
      this.selectDisabled6 = true;
      this.hidden3 = false;
      this.hidden3a = false;
      this.hidden4 = false;
      this.hidden4a = false;
      this.hidden4b = false;
      this.hidden4c = false;
      this.hidden4d = false;
      this.hidden5 = false;
      this.hidden6 = false;
    }
    else if (obj.value == 6) {
      this.spremenljivka = [
        {value: 'spr-9', viewValue: 'Referenčna evapotranspiracija'},
        //{value: 'spr-12', viewValue: 'Sprememba napajanja podzemne vode'},
        //{value: 'spr-19', viewValue: 'Odklon napajanja podzemne vode'},
        {value: 'spr-61', viewValue: 'Skupni odtok'},
        {value: 'spr-62', viewValue: 'Napajanje podzemnih voda'}
      ];
      this.selectDisabled3 = true;
      this.selectDisabled3a = true;
      this.selectDisabled4 = true;
      this.selectDisabled4a = true;
      this.selectDisabled4b = true;
      this.selectDisabled4c = true;
      this.selectDisabled4d = true;
      this.selectDisabled5 = true;
      this.selectDisabled6 = true;
      this.hidden3 = false;
      this.hidden3a = false;
      this.hidden4 = false;
      this.hidden4a = false;
      this.hidden4b = false;
      this.hidden4c = false;
      this.hidden4d = false;
      this.hidden5 = false;
      this.hidden6 = false;
    }
    else if (obj.value == 7) {
      this.spremenljivka = [
        {value: 'spr-14', viewValue: 'Mali pretoki'},
        {value: 'spr-15', viewValue: 'Srednji pretoki'},
        {value: 'spr-16', viewValue: 'Veliki pretoki'}
        //{value: 'spr-17', viewValue: 'Povratne dobe za nizke pretoke'},
        //{value: 'spr-18', viewValue: 'Povratne dobe za velike pretoke'}
      ];
      this.selectDisabled3 = true;
      this.selectDisabled3a = true;
      this.selectDisabled4 = true;
      this.selectDisabled4a = true;
      this.selectDisabled4b = true;
      this.selectDisabled4c = true;
      this.selectDisabled4d = true;
      this.selectDisabled5 = true;
      this.selectDisabled6 = true;
      this.hidden3 = false;
      this.hidden3a = false;
      this.hidden4 = false;
      this.hidden4a = false;
      this.hidden4b = false;
      this.hidden4c = false;
      this.hidden4d = false;
      this.hidden5 = false;
      this.hidden6 = false;
    }
    else if (obj.value == 8) {
      this.spremenljivka = [
        {value: 'spr-81', viewValue: 'SPI'},
        {value: 'spr-82', viewValue: 'SPEI'}
      ];
      this.selectDisabled3 = true;
      this.selectDisabled3a = true;
      this.selectDisabled4 = true;
      this.selectDisabled4a = true;
      this.selectDisabled4b = true;
      this.selectDisabled4c = true;
      this.selectDisabled4d = true;
      this.selectDisabled5 = true;
      this.selectDisabled6 = true;
      this.hidden3 = false;
      this.hidden3a = false;
      this.hidden4 = false;
      this.hidden4a = false;
      this.hidden4b = false;
      this.hidden4c = false;
      this.hidden4d = false;
      this.hidden5 = false;
      this.hidden6 = false;
    }

    else if (obj.value == 9) {
      this.spremenljivka = [
        { value: 'spr-91', viewValue: 'Temperaturni primanjkljaj' },
        { value: 'spr-92', viewValue: 'Temperaturni presežek' }
      ];
      this.selectDisabled3 = true;
      this.selectDisabled3a = true;
      this.selectDisabled4 = true;
      this.selectDisabled4a = true;
      this.selectDisabled4b = true;
      this.selectDisabled4c = true;
      this.selectDisabled4d = true;
      this.selectDisabled5 = true;
      this.selectDisabled6 = true;
      this.hidden3 = false;
      this.hidden3a = false;
      this.hidden4 = false;
      this.hidden4a = false;
      this.hidden4b = false;
      this.hidden4c = false;
      this.hidden4d = false;
      this.hidden5 = false;
      this.hidden6 = false;
    }

    else if (obj.value == 10) {
      this.spremenljivka = [
        {value: 'spr-101', viewValue: 'Sprememba trajanja pretoka v %'},
        {value: 'spr-102', viewValue: 'Sprememba trajanja pretoka v dnevih'}
      ];
      this.selectDisabled3 = true;
      this.selectDisabled3a = true;
      this.selectDisabled4 = true;
      this.selectDisabled4a = true;
      this.selectDisabled4b = true;
      this.selectDisabled4c = true;
      this.selectDisabled4d = true;
      this.selectDisabled5 = true;
      this.selectDisabled6 = true;
      this.hidden3 = false;
      this.hidden3a = false;
      this.hidden4 = false;
      this.hidden4a = false;
      this.hidden4b = false;
      this.hidden4c = false;
      this.hidden4d = false;
      this.hidden5 = false;
      this.hidden6 = false;
    }


    this.eventClicked1.emit(this.selected1);
    this.eventClicked2.emit(this.selected2);
    this.eventClicked3.emit(this.selected3);
    this.eventClicked3a.emit(this.selected3a);
    this.eventClicked4.emit(this.selected4);
    this.eventClicked4a.emit(this.selected4a);
    this.eventClicked4b.emit(this.selected4b);
    this.eventClicked4c.emit(this.selected4c);
    this.eventClicked4d.emit(this.selected4d);
    this.eventClicked5.emit(this.selected5);
    this.eventClicked6.emit(this.selected6);
  }
  
  secondDropDownChanged(value: any) {
    console.log(value);

    if (value == 'spr-3') {
      this.scenarij1 = [
        {value: 'scenarij-0', viewValue: 'RCP2.6'},
        {value: 'scenarij-1', viewValue: 'RCP4.5'},
        {value: 'scenarij-2', viewValue: 'RCP8.5'}
      ];
      this.selectDisabled3 = false;
      this.selectDisabled4 = true;
      this.selectDisabled4a = true;
      this.selectDisabled4b = true;
      this.selectDisabled4c = true;
      this.selectDisabled4d = true;
      this.selectDisabled5 = false;
      this.selectDisabled6 = true;
      this.hidden3 = true;
      this.hidden4 = false;
      this.hidden4a = false;
      this.hidden4b = false;
      this.hidden4c = false;
      this.hidden4d = false;
      this.hidden5 = true;
      this.hidden6 = false;
      this.tempKazalniki = this.tempKazalniki;
      this.selected4 = undefined;
      this.selected4a = undefined;
      this.selected4b = undefined;
      this.selected4c = undefined;
      this.selected4d = undefined;
      this.selected6 = undefined;
    }

    else if (value == 'spr-14' || value == 'spr-15' || value == 'spr-16' ) {
      this.scenarij1 = [
        {value: 'scenarij-0', viewValue: 'RCP2.6'},
        {value: 'scenarij-1', viewValue: 'RCP4.5'},
        {value: 'scenarij-2', viewValue: 'RCP8.5'}
      ];
      this.selectDisabled3 = true;
      this.selectDisabled4 = true;
      this.selectDisabled4a = true;
      this.selectDisabled4b = true;
      this.selectDisabled4c = true;
      this.selectDisabled4d = true;
      this.selectDisabled5 = false;
      this.selectDisabled6 = true;
      this.hidden3 = false;
      this.hidden4 = false;
      this.hidden4a = false;
      this.hidden4b = false;
      this.hidden4c = false;
      this.hidden4d = false;
      this.hidden5 = true;
      this.hidden6 = false;
      this.selected3 = undefined;
      this.selected4 = undefined;
      this.selected4a = undefined;
      this.selected4b = undefined;
      this.selected4c = undefined;
      this.selected4d = undefined;
      this.selected6 = undefined;
    }

    // else if (value == 'spr-12' || value == 'spr-19') {
    //   this.scenarij1 = [
    //     {value: 'scenarij-1', viewValue: 'RCP4.5'},
    //     {value: 'scenarij-2', viewValue: 'RCP8.5'}
    //   ];
    //   this.selectDisabled3 = true;
    //   this.selectDisabled4 = true;
    //   this.selectDisabled4a = true;
    //   this.selectDisabled4b = true;
    //   this.selectDisabled4c = true;
    //   this.selectDisabled4d = true;
    //   this.selectDisabled5 = false;
    //   this.selectDisabled6 = true;
    //   this.hidden3 = false;
    //   this.hidden4 = false;
    //   this.hidden4a = false;
    //   this.hidden4b = false;
    //   this.hidden4c = false;
    //   this.hidden4d = false;
    //   this.hidden5 = true;
    //   this.hidden6 = false;
    //   this.selected3 = undefined;
    //   this.selected4 = undefined;
    //   this.selected4a = undefined;
    //   this.selected4b = undefined;
    //   this.selected4c = undefined;
    //   this.selected4d = undefined;
    //   this.selected6 = undefined;
    // }
  
    else if (value == 'spr-17' || value == 'spr-18') {
      this.selectDisabled3 = true;
      this.selectDisabled4 = true;
      this.selectDisabled4a = true;
      this.selectDisabled4b = true;
      this.selectDisabled4c = true;
      this.selectDisabled4d = true;
      this.selectDisabled5 = true;
      this.selectDisabled6 = true;
      this.hidden3 = false;
      this.hidden4 = false;
      this.hidden4a = false;
      this.hidden4b = false;
      this.hidden4c = false;
      this.hidden4d = false;
      this.hidden5 = false;
      this.hidden6 = false;
      this.selected3 = undefined;
      this.selected4 = undefined;
      this.selected4a = undefined;
      this.selected4b = undefined;
      this.selected4c = undefined;
      this.selected4d = undefined;
      this.selected5 = undefined;
      this.selected6 = undefined;
    }

    else if (value == 'spr-8') {
      this.selectDisabled3 = true;
      this.selectDisabled4 = false;
      this.selectDisabled4a = true;
      this.selectDisabled4b = true;
      this.selectDisabled4c = true;
      this.selectDisabled4d = true;
      this.selectDisabled5 = true;
      this.selectDisabled6 = true;
      this.hidden3 = false;
      this.hidden4 = true;
      this.hidden4a = false;
      this.hidden4b = false;
      this.hidden4c = false;
      this.hidden4d = false;
      this.hidden5 = false;
      this.hidden6 = false;
      this.padKazalniki = this.padKazalniki;
      this.selected3 = undefined;
      this.selected4a = undefined;
      this.selected4b = undefined;
      this.selected4c = undefined;
      this.selected4d = undefined;
      this.selected5 = undefined;
      this.selected6 = undefined;
    }
    else if (value == 'spr-81') {
      this.scenarij1 = [
        {value: 'scenarij-0', viewValue: 'RCP2.6'},
        {value: 'scenarij-1', viewValue: 'RCP4.5'},
        {value: 'scenarij-2', viewValue: 'RCP8.5'}
      ];
      this.selectDisabled3 = true;
      this.selectDisabled4 = true;
      this.selectDisabled4a = false;
      this.selectDisabled4b = true;
      this.selectDisabled4c = true;
      this.selectDisabled4d = true;
      this.selectDisabled5 = true;
      this.selectDisabled6 = true;
      this.hidden3 = false;
      this.hidden4 = false;
      this.hidden4a = true;
      this.hidden4b = false;
      this.hidden4c = false;
      this.hidden4d = false;
      this.hidden5 = false;
      this.hidden6 = false;
      this.spi = this.spi;
      this.selected3 = undefined;
      this.selected4 = undefined;
      this.selected4a = undefined;
      this.selected4b = undefined;
      this.selected4c = undefined;
      this.selected4d = undefined;
      this.selected5 = undefined;
      this.selected6 = undefined;
    }
    else if (value == 'spr-82') {
      this.scenarij1 = [
        {value: 'scenarij-1', viewValue: 'RCP4.5'},
        {value: 'scenarij-2', viewValue: 'RCP8.5'}
      ];
      this.selectDisabled3 = true;
      this.selectDisabled4 = true;
      this.selectDisabled4a = true;
      this.selectDisabled4b = false;
      this.selectDisabled4c = true;
      this.selectDisabled4d = true;
      this.selectDisabled5 = false;
      this.selectDisabled6 = true;
      this.hidden3 = false;
      this.hidden4 = false;
      this.hidden4a = false;
      this.hidden4b = true;
      this.hidden4c = false;
      this.hidden4d = false;
      this.hidden5 = true;
      this.hidden6 = false;
      this.spei = this.spei;
      this.selected3 = undefined;
      this.selected4 = undefined;
      this.selected4a = undefined;
      this.selected4b = undefined;
      this.selected4c = undefined;
      this.selected4d = undefined;
      this.selected5 = undefined;
      this.selected6 = undefined;
    }

    else if (value == 'spr-91') {
      this.tempPrag = [
        {value: 'tempPrag-0', viewValue: 'Prag 12 °C'}
      ];
      this.scenarij1 = [
        {value: 'scenarij-0', viewValue: 'RCP2.6'},
        {value: 'scenarij-1', viewValue: 'RCP4.5'},
        {value: 'scenarij-2', viewValue: 'RCP8.5'}
      ];
      this.selectDisabled3 = true;
      this.selectDisabled3a = false;
      this.selectDisabled4 = true;
      this.selectDisabled4a = true;
      this.selectDisabled4b = true;
      this.selectDisabled4c = true;
      this.selectDisabled4d = true;
      this.selectDisabled5 = false;
      this.selectDisabled6 = false;
      this.hidden3 = false;
      this.hidden3a = true;
      this.hidden4 = false;
      this.hidden4a = false;
      this.hidden4b = false;
      this.hidden4c = false;
      this.hidden4d = false;
      this.hidden5 = true;
      this.hidden6 = true;
      this.selected3 = undefined;
      this.selected3a = undefined;
      this.selected4 = undefined;
      this.selected4a = undefined;
      this.selected4b = undefined;
      this.selected4c = undefined;
      this.selected4d = undefined;
    }

    else if (value == 'spr-92') {
      this.tempPrag = [
        {value: 'tempPrag-1', viewValue: 'Prag 18 °C'},
        {value: 'tempPrag-2', viewValue: 'Prag 21 °C'},
        {value: 'tempPrag-3', viewValue: 'Prag 23 °C'}
      ];
      this.scenarij1 = [
        {value: 'scenarij-0', viewValue: 'RCP2.6'},
        {value: 'scenarij-1', viewValue: 'RCP4.5'},
        {value: 'scenarij-2', viewValue: 'RCP8.5'}
      ];
      this.selectDisabled3 = true;
      this.selectDisabled3a = false;
      this.selectDisabled4 = true;
      this.selectDisabled4a = true;
      this.selectDisabled4b = true;
      this.selectDisabled4c = true;
      this.selectDisabled4d = true;
      this.selectDisabled5 = false;
      this.selectDisabled6 = false;
      this.hidden3 = false;
      this.hidden3a = true;
      this.hidden4 = false;
      this.hidden4a = false;
      this.hidden4b = false;
      this.hidden4c = false;
      this.hidden4d = false;
      this.hidden5 = true;
      this.hidden6 = true;
      this.selected3 = undefined;
      this.selected3a = undefined;
      this.selected4 = undefined;
      this.selected4a = undefined;
      this.selected4b = undefined;
      this.selected4c = undefined;
      this.selected4d = undefined;
    }

    else if (value == 'spr-101') {
      this.scenarij1 = [
        {value: 'scenarij-0', viewValue: 'RCP2.6'},
        {value: 'scenarij-1', viewValue: 'RCP4.5'},
        {value: 'scenarij-2', viewValue: 'RCP8.5'}
      ];
      this.selectDisabled3 = true;
      this.selectDisabled4 = true;
      this.selectDisabled4a = true;
      this.selectDisabled4b = true;
      this.selectDisabled4c = false;
      this.selectDisabled4d = true;
      this.selectDisabled5 = false;
      this.selectDisabled6 = true;
      this.hidden3 = false;
      this.hidden4 = false;
      this.hidden4a = false;
      this.hidden4b = false;
      this.hidden4c = true;
      this.hidden4d = false;
      this.hidden5 = true;
      this.hidden6 = false;
      this.pretok = this.pretok;
      this.selected3 = undefined;
      this.selected4 = undefined;
      this.selected4a = undefined;
      this.selected4b = undefined;
      this.selected4c = undefined;
      this.selected4d = undefined;
      this.selected5 = undefined;
      this.selected6 = undefined;
    }
    else if (value == 'spr-102') {
      this.scenarij1 = [
        {value: 'scenarij-0', viewValue: 'RCP2.6'},
        {value: 'scenarij-1', viewValue: 'RCP4.5'},
        {value: 'scenarij-2', viewValue: 'RCP8.5'}
      ];
      this.selectDisabled3 = true;
      this.selectDisabled4 = true;
      this.selectDisabled4a = true;
      this.selectDisabled4b = true;
      this.selectDisabled4c = true;
      this.selectDisabled4d = false;
      this.selectDisabled5 = false;
      this.selectDisabled6 = true;
      this.hidden3 = false;
      this.hidden4 = false;
      this.hidden4a = false;
      this.hidden4b = false;
      this.hidden4c = false;
      this.hidden4d = true;
      this.hidden5 = true;
      this.hidden6 = false;
      this.trajanje = this.trajanje;
      this.selected3 = undefined;
      this.selected4 = undefined;
      this.selected4a = undefined;
      this.selected4b = undefined;
      this.selected4c = undefined;
      this.selected4d = undefined;
      this.selected5 = undefined;
      this.selected6 = undefined;
    }
    else {
      this.scenarij1 = [
        {value: 'scenarij-0', viewValue: 'RCP2.6'},
        {value: 'scenarij-1', viewValue: 'RCP4.5'},
        {value: 'scenarij-2', viewValue: 'RCP8.5'}
      ];
      this.selectDisabled3 = true;
      this.selectDisabled4 = true;
      this.selectDisabled4a = true;
      this.selectDisabled4b = true;
      this.selectDisabled4c = true;
      this.selectDisabled4d = true;
      this.selectDisabled5 = false;
      this.selectDisabled6 = false;
      this.hidden3 = false;
      this.hidden4 = false;
      this.hidden4a = false;
      this.hidden4b = false;
      this.hidden4c = false;
      this.hidden4d = false;
      this.hidden5 = true;
      this.hidden6 = true;
      this.selected3 = undefined;
      this.selected4 = undefined;
      this.selected4a = undefined;
      this.selected4b = undefined;
      this.selected4c = undefined;
      this.selected4d = undefined;
    }

    this.eventClicked2.emit(this.selected2);
    this.eventClicked3.emit(this.selected3);
    this.eventClicked3a.emit(this.selected3a);
    this.eventClicked4.emit(this.selected4);
    this.eventClicked4a.emit(this.selected4a);
    this.eventClicked4b.emit(this.selected4b);
    this.eventClicked4c.emit(this.selected4c);
    this.eventClicked4d.emit(this.selected4d);
    this.eventClicked5.emit(this.selected5);
    this.eventClicked6.emit(this.selected6);


  }

  thirdDropDownChanged(value: any) {
    console.log(value);
  }

  thirdaDropDownChanged(value: any) {
    console.log(value);
  }

  fourthDropDownChanged(value: any) {
    console.log(value);

    if (value == 'padKaz-0' || value == 'padKaz-1' || value == 'padKaz-2' || value == 'padKaz-5') {
      this.scenarij1 = [
        {value: 'scenarij-0', viewValue: 'RCP2.6'},
        {value: 'scenarij-1', viewValue: 'RCP4.5'},
        {value: 'scenarij-2', viewValue: 'RCP8.5'}
      ];
      this.selectDisabled3 = true;
      this.selectDisabled4 = false;
      this.selectDisabled5 = false;
      this.selectDisabled6 = true;
      this.hidden3 = false;
      this.hidden4 = true;
      this.hidden5 = true;
      this.hidden6 = false;
      this.selected3 = undefined;
      this.selected6 = undefined;
    }

    else {
      this.selectDisabled3 = true;
      this.selectDisabled4 = false;
      this.selectDisabled5 = false;
      this.selectDisabled6 = false;
      this.hidden3 = false;
      this.hidden4 = true;
      this.hidden5 = true;
      this.hidden6 = true;
      this.selected3 = undefined;
    }

    this.eventClicked4.emit(this.selected4);
    this.eventClicked5.emit(this.selected5);
    this.eventClicked6.emit(this.selected6);

  } 

  fourthaDropDownChanged(value: any) {
    console.log(value);

    if (value == 'spi-0' || value == 'spi-2' || value == 'spi-6') {
      this.scenarij1 = [
        {value: 'scenarij-0', viewValue: 'RCP2.6'},
        {value: 'scenarij-1', viewValue: 'RCP4.5'},
        {value: 'scenarij-2', viewValue: 'RCP8.5'}
      ];
      this.selectDisabled5 = false;
      this.selectDisabled6 = false;      
      this.hidden5 = true;
      this.hidden6 = true;
    }
    else {
      this.scenarij1 = [
        {value: 'scenarij-0', viewValue: 'RCP2.6'},
        {value: 'scenarij-1', viewValue: 'RCP4.5'},
        {value: 'scenarij-2', viewValue: 'RCP8.5'}
      ];
      this.selectDisabled5 = false;
      this.selectDisabled6 = true;
      this.hidden5 = true;
      this.hidden6 = false;
      this.selected6 = undefined;
    }

    this.eventClicked4a.emit(this.selected4a);
    this.eventClicked5.emit(this.selected5);
    this.eventClicked6.emit(this.selected6);
  }
  

  fourthbDropDownChanged(value: any) {
    console.log(value);
  } 

  fourthcDropDownChanged(value: any) {
    console.log(value);
  } 

  fourthdDropDownChanged(value: any) {
    console.log(value);
  } 

  fifthDropDownChanged(value: any) {
    console.log(value);
  } 

  sixthDropDownChanged(value: any) {
    console.log(value);
  }

  @Output() eventClicked1 = new EventEmitter<Event>();
  @Output() eventClicked2 = new EventEmitter<Event>();
  @Output() eventClicked3 = new EventEmitter<Event>();
  @Output() eventClicked3a = new EventEmitter<Event>();
  @Output() eventClicked4 = new EventEmitter<Event>();
  @Output() eventClicked4a = new EventEmitter<Event>();
  @Output() eventClicked4b = new EventEmitter<Event>();
  @Output() eventClicked4c = new EventEmitter<Event>();
  @Output() eventClicked4d = new EventEmitter<Event>();
  @Output() eventClicked5 = new EventEmitter<Event>();
  @Output() eventClicked6 = new EventEmitter<Event>();

  constructor(private router: Router,
    private route: ActivatedRoute) { }

  ngOnInit() {
  }

  onClick1(selected1: Event): void {
    this.eventClicked1.emit(selected1);
  }

  onClick2(selected2: Event): void {
    this.eventClicked2.emit(selected2);
  }

  onClick3(selected3: Event): void {
    this.eventClicked3.emit(selected3);
  }

  onClick3a(selected3a: Event): void {
    this.eventClicked3a.emit(selected3a);
  }

  onClick4(selected4: Event): void {
    this.eventClicked4.emit(selected4);
  }

  onClick4a(selected4a: Event): void {
    this.eventClicked4a.emit(selected4a);
  }

  onClick4b(selected4b: Event): void {
    this.eventClicked4b.emit(selected4b);
  }

  onClick4c(selected4c: Event): void {
    this.eventClicked4c.emit(selected4c);
  }

  onClick4d(selected4d: Event): void {
    this.eventClicked4d.emit(selected4d);
  }

  onClick5(selected5: Event): void {
    this.eventClicked5.emit(selected5);
  }

  onClick6(selected6: Event): void {
    this.eventClicked6.emit(selected6);
  }

}
